import { createHttpLink } from '@apollo/client';
import { UPHEAL_GRAPHQL_API_URL } from '../configuration';

const isLocalDevelopment =
    import.meta.env.VITE_REACT_APP_SERVER_STAGE === 'local';

export const httpLink = createHttpLink({
    uri: UPHEAL_GRAPHQL_API_URL,
    ...(isLocalDevelopment && { credentials: 'include' }),
});
